import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { ComponentTrustpilot } from '~components/ComponentTrustpilot';
import { InfiniteScroll } from '~components/InfiniteScroll';
import { useHero } from '../useHero';

import FinancieeleDagbladLogo from '../assets/Financieele_Dagblad-Logo.svg';
import TechcrunchLogo from '../assets/Techcrunch-Logo.svg';
import DeVolkskrantLogo from '../assets/deVolkskrant-Logo.svg';
import ForbesLogo from '../assets/Forbes-Logo.svg';
import BusinessInsiderLogo from '../assets/BusinessInsider-Logo.svg';
import HetParoolLogo from '../assets/HetParool-Logo.svg';
import EmerceLogo from '../assets/Emerce-Logo.svg';

import * as styles from './BottomBar.module.css';

const partnerLogos = [
  { Component: FinancieeleDagbladLogo, alt: 'Het Financieele Dagblad' },
  { Component: TechcrunchLogo, alt: 'TechCrunch' },
  { Component: DeVolkskrantLogo, alt: 'de Volkskrant' },
  { Component: ForbesLogo, alt: 'Forbes' },
  { Component: BusinessInsiderLogo, alt: 'Business Insider' },
  { Component: HetParoolLogo, alt: 'Het Parool' },
  { Component: EmerceLogo, alt: 'Emerce' },
];

export const BottomBar: React.FC = () => {
  const { animationState } = useHero();
  const [hide, setHide] = useState<boolean>(false);

  useEffect(() => {
    const trigger = () => setHide(window.scrollY > 50);
    window.addEventListener('scroll', trigger);
    return () => window.removeEventListener('scroll', trigger);
  }, []);

  return (
    <div className={clsx(styles.bottomBar, animationState !== 'initial' && styles.animating, hide && styles.hide)}>
      <ComponentTrustpilot
        className={styles.trustpilot}
        key={(animationState === 'initial').toString()}
        trustpilot={{ theme: animationState === 'initial' ? 'dark' : 'light' }}
      />
      <InfiniteScroll className={styles.partnerLogos}>
        {partnerLogos.map(({ Component, alt }) => (
          <Component
            className={Component === EmerceLogo ? styles.emerceLogo : styles.logo}
            key={alt}
            aria-label={alt}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};
